import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import "@/App.css";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { I18nProvider, useT } from "@/i18n/I18nContext";
import { Toaster } from "@/components/ui/sonner";
import Login from "@/pages/Login";
import PaymentSuccess from "@/pages/PaymentSuccess";
import PaymentCancelled from "@/pages/PaymentCancelled";
import PublicContract from "@/pages/PublicContract";
import DashboardLayout from "@/components/DashboardLayout";
import Dashboard from "@/pages/Dashboard";
import Frota from "@/pages/Frota";
import Clientes from "@/pages/Clientes";
import Alugueis from "@/pages/Alugueis";
import Pagamentos from "@/pages/Pagamentos";
import Manutencao from "@/pages/Manutencao";
import GPS from "@/pages/GPS";
import Financeiro from "@/pages/Financeiro";
import Cobranca from "@/pages/Cobranca";
import BI from "@/pages/BI";
import RentalWizard from "@/pages/RentalWizard";
import Today from "@/pages/Today";
import SelfCheckin from "@/pages/SelfCheckin";
import Multas from "@/pages/Multas";
import Pedagios from "@/pages/Pedagios";
import Profile from "@/pages/Profile";
import Activity from "@/pages/Activity";
import Usuarios from "@/pages/Usuarios";
import AcceptInvite from "@/pages/AcceptInvite";

function LoadingScreen() {
  const { t } = useT();
  return (
    <div className="min-h-screen flex items-center justify-center bg-white">
      <div className="overline">{t("common.loading")}</div>
    </div>
  );
}

function ProtectedRoute({ children }) {
  const { user } = useAuth();
  if (user === null) return <LoadingScreen />;
  if (!user) return <Navigate to="/login" replace />;
  return children;
}

function PublicOnly({ children }) {
  const { user } = useAuth();
  if (user === null) return <LoadingScreen />;
  if (user) return <Navigate to="/" replace />;
  return children;
}

export default function App() {
  return (
    <div className="App">
      <I18nProvider>
        <AuthProvider>
          <BrowserRouter>
            <Routes>
              <Route path="/login" element={<PublicOnly><Login /></PublicOnly>} />
              <Route path="/accept-invite/:token" element={<AcceptInvite />} />
              <Route path="/payment-success" element={<PaymentSuccess />} />
              <Route path="/payment-cancelled" element={<PaymentCancelled />} />
              <Route path="/c/:token" element={<PublicContract />} />
              <Route path="/checkin/:token" element={<SelfCheckin />} />
              <Route
                path="/aluguel/novo"
                element={
                  <ProtectedRoute>
                    <RentalWizard />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/"
                element={
                  <ProtectedRoute>
                    <DashboardLayout />
                  </ProtectedRoute>
                }
              >
                <Route index element={<Dashboard />} />
                <Route path="frota" element={<Frota />} />
                <Route path="clientes" element={<Clientes />} />
                <Route path="alugueis" element={<Alugueis />} />
                <Route path="pagamentos" element={<Pagamentos />} />
                <Route path="manutencao" element={<Manutencao />} />
                <Route path="gps" element={<GPS />} />
                <Route path="financeiro" element={<Financeiro />} />
                <Route path="cobranca" element={<Cobranca />} />
                <Route path="bi" element={<BI />} />
                <Route path="hoje" element={<Today />} />
                <Route path="multas" element={<Multas />} />
                <Route path="pedagios" element={<Pedagios />} />
                <Route path="atividade" element={<Activity />} />
                <Route path="usuarios" element={<Usuarios />} />
                <Route path="profile" element={<Profile />} />
              </Route>
            </Routes>
          </BrowserRouter>
          <Toaster position="top-right" richColors closeButton />
        </AuthProvider>
      </I18nProvider>
    </div>
  );
}
